module.exports = __webpack_public_path__ + "static/img/short16.f05c761.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/short16.png
// module id = SPZa
// module chunks = 0